import React from 'react';
import PropTypes from 'prop-types';
import TooltipStyled from './Tooltip.styled';

const Tooltip = ({ children, placement, title, ...props }) => {
  return (
    <TooltipStyled title={title} placement={placement} {...props}>
      {children}
    </TooltipStyled>
  );
};

Tooltip.propTypes = {
  title: PropTypes.string.isRequired,
  placement: PropTypes.string.isRequired,
  children: PropTypes.any,
};

Tooltip.defaultProps = {
  title: '',
  placement: 'bottom',
  children: null,
};

export default Tooltip;
